import React from 'react'
import StarRatingComponent from 'react-star-rating-component'
import StarRoundedIcon from '@material-ui/icons/StarRounded'
import utils from 'Utils'

const CommentItem = ({ comment }) =>
    <div className="comments__item">
        <div className="comment-info">
            <div className="name">{comment.fname + ' ' + comment.lname}</div>
            <div className="rate">
                <StarRatingComponent
                    name="rate of doctor"
                    editing={false}
                    renderStarIcon={() => <StarRoundedIcon style={{ display: 'flex', fontSize: '10px', marginLeft: 2 }} />}
                    starCount={5}
                    value={parseInt(comment.rate) || 0}
                />
            </div>
        </div>
        <div className="comment-detail">
            <div className="comment">{comment.comment}</div>
            <div className="date">{utils.getJalaiData(comment.createdAt) + ' - ' + utils.timeStampToHHMM(comment.createdAt)}</div>
        </div>
    </div>

export default CommentItem